<template>
  <div></div>
</template>
<script>

export default {
  name: 'NoBackPage',
  mounted() {
    // some no-back calls want to forward a query to the next page
    this.$router.push({ name: this.$route.params.page, query: this.$route.query, params: this.$route.params })
  },
  beforeRouteEnter(to, from, next) {
    if (to.params && to.params.page) {
      next() // this goes to the page we pushed in mounted()
    } else {
      next(false) // abort and reset to the 'from' route
    }
  }
}
</script>
